import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import ChartDetailsTable from '../tabs/activities/components/chartDetails/ChartDetailsTable'
import TableEmpty from '../shared/tableItems/TableEmpty'
import { useSideSelectionStore } from '../stores/sideSelectionStore'
import { useDate } from '@/modules/drivers/stores/dateStore'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { DRIVER_ROUTES } from '../routes-typed'

export const DriverGroupChartDetailsPage = () => {
  const { companyId, from, to } = useParams<{
    companyId: string
    from?: string
    to?: string
  }>()
  const navigate = useNavigate()
  const { sideCheckedIds } = useSideSelectionStore()
  const { getDateRangeForView } = useDate()
  const { t } = useLocalize()

  React.useEffect(() => {
    if (!companyId || (from && to)) return
    const { from: defaultFrom, to: defaultTo } = getDateRangeForView()
    if (!defaultFrom || !defaultTo) return
    navigate(
      DRIVER_ROUTES.groupChartDetails.buildPath({
        companyId,
        from: defaultFrom,
        to: defaultTo,
      }),
      { replace: true },
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, from, to])

  const driverIds = React.useMemo(
    () => sideCheckedIds.filter((id) => Number.isFinite(id)),
    [sideCheckedIds],
  )

  if (!from || !to) return null

  if (driverIds.length === 0) {
    return (
      <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden">
        <TableEmpty title={t('menu.select-drivers')} />
      </div>
    )
  }

  return (
    <ChartDetailsTable
      companyId={companyId as string}
      driverIds={driverIds}
      startTime={from}
      endTime={to}
    />
  )
}

export default DriverGroupChartDetailsPage
